'use client';

import { wrapUrlSafe } from '@alltrails/shared/utils/languageSupport';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import Image from '@alltrails/core/components/Image';
import { usePOIProfilePhoto } from '@alltrails/explore-service/hooks/usePOIProfilePhoto';
import { useState } from 'react';
import getPOIIcon from '@alltrails/search/utils/getPOIIcon';
import ChevronSm from '@alltrails/denali/icons/ChevronSm';
import Typography from '@alltrails/core/components/Typography';
import PhotoSlash from '@alltrails/denali/icons/PhotoSlash';
import styles from './TopSights.module.scss';
import { PointOfInterest } from '@/types/locationDetailsPages/shared';

const thumbnailSize = 48;

type TopSightCardProps = {
  poi: PointOfInterest;
  isBot?: boolean;
};

const TopSightCard = ({ poi, isBot }: TopSightCardProps) => {
  const languageRegionCode = useLanguageRegionCode();

  const [renderPhoto, setRenderPhoto] = useState(true);
  const profilePhotoSrc = usePOIProfilePhoto({ poiId: poi.id, height: thumbnailSize * 2, width: thumbnailSize * 2 });

  let thumbnail = <div />;
  if (renderPhoto && profilePhotoSrc) {
    thumbnail = <Image alt={poi.name} className={styles.image} fill onError={() => setRenderPhoto(false)} src={profilePhotoSrc} />;
  } else if (poi.type) {
    const IconComponent = getPOIIcon(poi.type, true /* filled */);
    thumbnail = <IconComponent color="--color-neutral-white" size="md" />;
  } else {
    thumbnail = <PhotoSlash color="--color-neutral-white" size="md" />;
  }

  return (
    <a key={poi.name} href={wrapUrlSafe(`/poi/${poi.slug}`, languageRegionCode)} className={styles.card}>
      <div className={styles.thumbnail}>{thumbnail}</div>
      <div className={styles.text}>
        <Typography className={!isBot ? styles.truncated : undefined} component="div" variant="text200bold">
          {poi.name}
        </Typography>
        {poi.type ? (
          <Typography className={!isBot ? styles.truncated : undefined} color="secondary" component="div" variant="text100">
            {poi.typeLabel}
          </Typography>
        ) : null}
      </div>
      <ChevronSm className={styles.chevron} color="--color-text-secondary" orientation="right" />
    </a>
  );
};

export default TopSightCard;
